"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectors = exports.useActions = exports.useScope = void 0;
const react_1 = require("react");
const store_context_1 = require("./store-context");
const utils_1 = require("./utils");
const react_redux_1 = require("react-redux");
function useScope(scopeName) {
    const { getScope } = (0, react_1.useContext)(store_context_1.RestateContext);
    return getScope(scopeName);
}
exports.useScope = useScope;
function useActions(scopeName) {
    const scope = useScope(scopeName);
    return scope.actions;
}
exports.useActions = useActions;
function useSelectors(scopeName) {
    const scope = useScope(scopeName);
    const { subscribe } = (0, react_redux_1.useStore)();
    const forceUpdate = (0, utils_1.useForceUpdate)();
    (0, react_1.useEffect)(() => subscribe(forceUpdate), [subscribe, forceUpdate]);
    return scope.model.selectors;
}
exports.useSelectors = useSelectors;
//# sourceMappingURL=hooks.js.map